import type { ItemProps, RootProps } from './Benefits.types'
import cn from 'classnames'
import * as React from 'react'
import { Icon } from '../icon'
import { RichText } from '../rich-text'
import { Typography } from '../typography'
import styles from './Benefits.module.css'

export function Root({ display = 'inlineCenter', children, className, ...rest }: RootProps) {
  return (
    <ul
      className={cn(
        styles.root,
        styles[display],
        className,
      )}
      {...rest}
    >
      {children}
    </ul>
  )
}

export function Item({ icon, iconClassName, title, supportingText, className, ...rest }: ItemProps) {
  return (
    <li className={cn(styles.item, className)} {...rest}>
      <div className={styles.itemWrapper}>
        <Icon className={cn(styles.icon, iconClassName)} glyph={icon ?? 'CheckMarkSmall'} size={24} aria-hidden />
        <div className={styles.textWrapper}>
          <Typography variant={supportingText ? 'body-m-bold-tight' : 'body-m-regular-tight'}>{title}</Typography>
          {supportingText && (
            <RichText className={styles.supportingText} innerHTML={supportingText} />
          )}
        </div>
      </div>
    </li>
  )
}
